import i18n from 'services/i18n'

export const orderTypes = {
    NEW_TO_OLD: {
        labelDomain: 'CollectionFilter.from_new_to_old',
        type: 'date',
        order: 'desc',
        listOrder: 1
    },
    OLD_TO_NEW: {
        labelDomain: 'CollectionFilter.from_old_to_new',
        type: 'date',
        order: 'asc',
        listOrder: 2
    },
    A_TO_Z: {
        labelDomain: 'CollectionFilter.alpha_order_asc',
        type: 'alphabetic',
        order: 'asc',
        listOrder: 3
    },
    Z_TO_A: {
        labelDomain: 'CollectionFilter.alpha_order_desc',
        type: 'alphabetic',
        order: 'desc',
        listOrder: 4
    },
    RELEVANCE: {
        labelDomain: 'CollectionFilter.search_score',
        type: 'relevance',
        order: 'desc',
        listOrder: 5
    }
}
export const mapOrderTypeToSortValue = ({ type, order }) => ({ type, order })

export const getOrderTypeOptions = () => Object
    .entries(orderTypes)
    .map(([, config]) => config)
    .sort((a, b) => a.listOrder - b.listOrder)
    .map(({ labelDomain, type, order }) => ({
        label: i18n.t(labelDomain),
        type,
        order
    }))
